import FormattedMessage from 'I18n/components/FormattedMessage';
import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import { useFormattedFeatureTableBodyData } from '../../components/feature-table/useFormattedFeatureTableBodyData';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionsByProductApiNameAndLocation } from '../../containers/PurchaseMotionsByProductApiNameAndLocation';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentHubFeatureTable = () => {
  const formattedFeatureTableBodyData = useFormattedFeatureTableBodyData({
    productApiNames: ['cms-hub-starter', 'cms-hub-professional', 'cms-hub-enterprise']
  });
  if (formattedFeatureTableBodyData.error) {
    return null;
  }
  if (formattedFeatureTableBodyData.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: 1500
    });
  }

  // If the fetch for data is successful and there are no features
  // don't render the table because the purchase motions are identical
  // to that of the merch card
  if (formattedFeatureTableBodyData.data.sectionData.all.features.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    canViewNewSeats: true,
    headerData: {
      'cms-hub-starter': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.content.starterCard.title"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "cms-hub-starter"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "cms-hub-starter",
            location: "MERCH_CARD",
            displayCount: 1
          })
        })
      },
      'cms-hub-professional': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.content.professionalCard.title"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "cms-hub-professional"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "cms-hub-professional",
            location: "MERCH_CARD",
            displayCount: 1
          })
        })
      },
      'cms-hub-enterprise': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.content.enterpriseCard.title"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "cms-hub-enterprise"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "cms-hub-enterprise",
            location: "MERCH_CARD",
            displayCount: 1
          })
        })
      }
    },
    bodyData: formattedFeatureTableBodyData.data
  });
};